import React from "react";

function Maximize() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                Crypto Arbitrage Bot Development to Maximize Your Crypto Trading
                Profit
              </h2>
              <p>
                Unlock the potential of cryptocurrency markets with an advanced
                arbitrage trading bot designed to automatically detect and
                capitalize on price discrepancies across multiple exchanges.
                These bots use sophisticated algorithms to track real-time price
                variations for the same asset and execute buy and sell orders in
                a matter of seconds, ensuring you capture profit from market
                inefficiencies without manual intervention.
              </p>
              <p>
                By automating the entire arbitrage process, these bots minimize
                the risks associated with human error and slow decision-making,
                allowing for seamless, round-the-clock trading.
              </p>
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Maximize;
